import classNames from "classnames"
import React from "react"
import { SwiperSlide } from "swiper/react"

import SingleEntryCellData from "./SingleEntryCellData"
import { extractFromTag } from "./utils"
import { Color } from "../../../../constants/V2/color"
import GatsbyStoryblokImage from "../../../elements/V2/GatsbyStoryblokImage"

type SwiperSlideHeadersProps = {
  data: string[][]
  columnImages?: string[]
  columnCount: number
  numDesktopColumns: number
  tableTheme: "light" | "dark"
  backgroundColor: Color.Black | Color.Charcoal | Color.White | Color.MintGreen
  titleRowIndices: React.MutableRefObject<number[]>
}

const SwiperSlideHeaders = ({
  data,
  columnImages,
  columnCount,
  numDesktopColumns,
  tableTheme,
  backgroundColor,
  titleRowIndices,
}: SwiperSlideHeadersProps) => {
  const tableColumns = []

  for (let colIndex = 0; colIndex < columnCount; colIndex++) {
    const columnHeading = data[0][colIndex] || ""
    tableColumns.push(
      <SwiperSlide
        key={`${columnHeading.replace(" ", "-")}-${colIndex}`}
        className="swiper-no-swiping"
      >
        <div
          className={classNames("flex items-center justify-center", {
            "h-40":
              columnCount > numDesktopColumns &&
              !(columnImages && columnImages.length > 0),
            "h-[92px] lg:h-[128px]": columnImages && columnImages.length > 0,
          })}
        >
          {columnImages && columnImages[colIndex] && (
            <div className="aspect-square h-full w-auto">
              <GatsbyStoryblokImage
                aspectRatio="fullWidth"
                image={extractFromTag(columnImages[colIndex], "image")}
                alt={columnHeading}
                className="h-full w-auto"
                testId="comparison-table-slide-image"
              />
            </div>
          )}
        </div>
        <SingleEntryCellData
          rowIndex={0}
          columnIndex={colIndex}
          data={data}
          columnCount={columnCount}
          tableTheme={tableTheme}
          backgroundColor={backgroundColor}
          titleRowIndices={titleRowIndices}
        />
      </SwiperSlide>
    )
  }

  return tableColumns
}

export default SwiperSlideHeaders
